'use strict';

module.exports = '3.23.0';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/version.js
// module id = 337
// module chunks = 0